import { useEffect, useState } from 'react';

export const FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';

export function useFinePointer(): boolean {
    const [hasFinePointer, setHasFinePointer] = useState(false);

    useEffect(() => {
        const query = window.matchMedia(FINE_POINTER_QUERY);
        const update = () => setHasFinePointer(query.matches);
        update();
        query.addEventListener('change', update);
        return () => query.removeEventListener('change', update);
    }, []);

    return hasFinePointer;
}
